import angular from "angular";
import salesInfoTemplate from "./salesInfo.template.html";

/*******************************************************************************
 * Component: salesInfoItemContent
 *
 * This is the component to be used to manage the sales information for product
 * items in the AddChangeItemDialog. This will utilize the addChangeItemDialog's
 * component controller for shared data management.
 *******************************************************************************/
export const salesInfoItemContentComponent = {
  require: { dialogCtrl: '^^addChangeItemDialogContent' },
  template: salesInfoTemplate,
  controller: Controller,
  controllerAs: '$salesCtrl',
  transclude: {
    singleSalesAcctInfo: '?singleSalesAcctInfo'
  }
}

/* @ngInject */ function Controller(
  $element,
  $injector,
  $transclude,
  ItemSaleLimiterDialog,
  SERVER
) {
  /*****************************************************************************
   * Properties
   *****************************************************************************/
  var $salesCtrl = this;
  var $global = {};
  var $svcs = {
    $salesCtrl: $salesCtrl,
    $element: $element,
    $transclude: $transclude,
    $global: $global
  };

  $global.limitersDialogActive = false;

  Object.assign($salesCtrl, {
    accountLabel: SERVER.BooksWebConstants.accountLabel, // Account Label.
    identifyLabel: SERVER.BooksWebConstants.identifyLabel, // Identity Purchase Label.
    showAccountNumber: SERVER.BooksWebConstants.showAcctNumber, // Show Account Number Flag.
    validators: {}, // Content Validators. Populated by csmValidators directive.

    $onInit: $injector.invoke($onInit, null, $svcs),
    disableSplitButton: $injector.invoke(disableSplitButton, null, $svcs),
    handleItemLimitersDialog: $injector.invoke(
      handleItemLimitersDialog,
      null,
      $svcs
    )
  });

  /*---------------------------------------------------*/
  /* Set up an accessor the item property from the     */
  /* dialogCtrl. Use an empty object for data binding. */
  /*---------------------------------------------------*/
  Object.defineProperty($salesCtrl, 'item', {
    get: function () {
      return $salesCtrl.dialogCtrl ? $salesCtrl.dialogCtrl.item : {};
    }
  });
}

/***************************************************************************
 * disableSplitButton */
/**
 * Used to disable the split account button and set the correct tooltip text.
 *
 * @return  Boolean  Indication to disable/enable split button
 ***************************************************************************/
/* @ngInject */ function disableSplitButton($salesCtrl) {
  return function () {
    /*-------------------*/
    /* Set tooltip text. */
    /*-------------------*/
    $salesCtrl.tooltipText =
      $salesCtrl.dialogCtrl.uiFlags.isInvProduct &&
      $salesCtrl.dialogCtrl.uiFlags.forTrust
        ? 'Trust ' +
          $salesCtrl.accountLabel.toLowerCase() +
          ' cannot be split when inventory tracked'
        : 'Click to split ' + $salesCtrl.accountLabel.toLowerCase();

    return (
      $salesCtrl.dialogCtrl.uiFlags.isInvProduct &&
      $salesCtrl.dialogCtrl.uiFlags.forTrust
    );
  };
}

/***************************************************************************
 * handleItemLimitersDialog */
/**
 * Sales Limiter click button handler. This will handle the displaying of the
 * ItemSaleLimiterDialog.
 ***************************************************************************/
/* @ngInject */ function handleItemLimitersDialog(
  $global,
  $salesCtrl,
  ItemSaleLimiterDialog
) {
  return function () {
    /*------------------------------*/
    /* Dialog already active, exit. */
    /*------------------------------*/
    if ($global.limitersDialogActive) return;

    /*-------------------------*/
    /* Ensure the list exists. */
    /*-------------------------*/
    if (!$salesCtrl.item.statusTags) $salesCtrl.item.statusTags = [];

    /*------------------------------------------------*/
    /* Set the properties to be passed to the dialog. */
    /*------------------------------------------------*/
    var limiter = $salesCtrl.item.limiter || null;
    var statuses = $salesCtrl.item.statusTags;
    var tags = $salesCtrl.dialogCtrl.tagLists.statusTags;

    /*---------------------*/
    /* Display the dialog. */
    /*---------------------*/
    $global.limitersDialogActive = true;
    ItemSaleLimiterDialog.show(
      limiter,
      statuses,
      tags,
      $salesCtrl.item.saleStartDate,
      $salesCtrl.item.saleEndDate
    )
      .then(function (result) {
        /*----------------------------------------*/
        /* Update the item with the new limiters. */
        /*----------------------------------------*/
        $salesCtrl.item.limiter = result.limiter;

        /*----------------------------*/
        /* Update the limiters dates. */
        /*----------------------------*/
        $salesCtrl.item.saleStartDate = result.dates.startDate;
        $salesCtrl.item.saleEndDate = result.dates.endDate;

        /*-----------------------------------------------------*/
        /* Compare the edited statuses to the list of incoming */
        /* tags, and update the required and restricted flags. */
        /*-----------------------------------------------------*/
        var statuses = result.statuses;
        var tags = $salesCtrl.item.statusTags.concat();

        angular.forEach(tags, function (tag) {
          var status = statuses
            .filter(function (s) {
              return s.id == tag.id;
            })
            .shift();

          /*-------------------------------------*/
          /* If a match is found, set the flags. */
          /*-------------------------------------*/
          if (status) {
            tag.required = status.required;
            tag.restricted = status.restricted;

            /*-------------------------------------*/
            /* Remove from the main statuses list. */
            /*-------------------------------------*/
            statuses.splice(statuses.indexOf(status), 1);
          } else

          /*------------------------------------------*/
          /* Otherwise, remove it from the main list. */
          /*------------------------------------------*/
            $salesCtrl.item.statusTags.splice(
              $salesCtrl.item.statusTags.indexOf(tag),
              1
            );
        });

        /*---------------------------------------------*/
        /* Add any extra statuses to the list of tags. */
        /*---------------------------------------------*/
        Array.prototype.push.apply($salesCtrl.item.statusTags, statuses);
      })
      ['finally'](function () {
        $global.limitersDialogActive = false;
      });
  };
}

/*****************************************************************************
 * onInit */
/**
 * Component initialization callback function. Set the validator object reference
 * on the tab object.
 *****************************************************************************/
/* @ngInject */ function $onInit(
  $salesCtrl,
  $element,
  $transclude,
  CompilerService
) {
  return function () {
    $salesCtrl.dialogCtrl.tabSalesInfo.validators = $salesCtrl.validators;

    /*------------------------------------------------------------------*/
    /* Insert transcluded content and add reference to this controller. */
    /*------------------------------------------------------------------*/
    CompilerService.transcludeSlots(
      $element,
      { $salesCtrl: this },
      $transclude
    );
  };
}
